import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getOneStoreQuotation = createAsyncThunk(
    "/store/get-store-one-quotation",
    async (id) => {
        try {
            const myurl = `${V_URL}/prosafe/quotation/get-one-quotation/${id}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const initialState = {
    user: null,
    loading: false,
    error: null,
};

const getOneStoreQuotationSlice = createSlice({
    name: "getOneStoreQuotation",
    initialState,
    reducers: {
        resetGetOneStoreQuotation: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOneStoreQuotation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getOneStoreQuotation.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getOneStoreQuotation.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetOneStoreQuotation } = getOneStoreQuotationSlice.actions;

export default getOneStoreQuotationSlice.reducer;
